export default __webpack_public_path__ + "static/brush-after-e069bfae26d77765ec56e0ebe3bd0560.png";